// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jitO","rootNoMargin":"styles_rootNoMargin__2afj-"};